<div class="people">
  <div class="icon icon-users"></div>
  <p>{{ trip().memberCount }}</p>
</div>
<div class="status-list">
  @if (showOwner() && isOwner()) {
    <p class="status me all-caps">Owner</p>
  }
  <p class="status all-caps">{{ trip().status }}</p>
</div>
<div class="info">
  <a class="card-link" [routerLink]="['/trip', trip().tripId]" [state]="trip()">
    <h3 class="heading-md text-ellipsis">
      {{ trip().title }}
    </h3>
  </a>
  <p class="trip-description body-copy-bold">{{ tripDescription() }}</p>
  <p class="body-copy-sm">{{ trip().createdAt | relativeTime }}</p>
</div>
